import instance from './axios'

//获取人员列表接口
export const getList = (para) => {
  return instance.get('/account/list', {params: para})
}
//启用/禁用人员接口
export const toggle = (para) => {
  return instance.post('/account/toggle/status', para)
}


//权限
export const permission = (para) => {
  return instance.get('/account/role/list', {params: para})
}

//权限
export const specail = (para) => {
  return instance.get('/account/role/special/permission/list', {params: para})
}

//新增
export const addUser = (para) => {
  return instance.post('/account/add', para)
}


//修改
export const reviseUser = (para) => {
  return instance.post('/account/update', para)
}

//获取详情
export const getDetail = (para) => {
  return instance.get('/account/detail', {params: para})
}

//獲取公司關係
export const relation = (para) => {
  return instance.get('/company/all/list', {params: para})
}
//添加公司接口
export const addCorporation = (para) => {
  return instance.post('/company/add', para)
}

//修改公司接口
export const updateCorporation = (para) => {
  return instance.post('/company/update', para)
}


//详情公司接口
export const getCorporation = (para) => {
  return instance.get('/company/detail', {params: para})
}

//删除公司接口
export const deleteCorporation = (para) => {
  return instance.post('/company/delete', para)
}


//获取角色列表接口
export const getRoleList = (para) => {
  return instance.get('/account/role/list', {params: para})
}

//启用/禁用角色接口
export const toggleRole = (para) => {
  return instance.post('/account/role/toggle/status', para)
}


//资产报表统计列表
export const getAssetAllFieldList = (para) => {
  return instance.post('/asset/getAssetAllFieldList', para)
}

//获取可选的资产字段
export const getAssetOptionalField = (para) => {
  return instance.get('/asset/getAssetOptionalField',{params: para})
}

//导出
export const exportAssetOptional = (para) => {
  return instance.post('/asset/exportAssetOptional', para,{
    responseType:'arraybuffer',
  })
}

//获取权限
export const getPermissionList = (para) => {
  return instance.get('/account/role/permission/list',{params: para})
}



//获取详情
export const getDetailUser = (para) => {
  return instance.get('/account/role/detail', {params: para})
}

//修改
export const updateUser = (para) => {
  return instance.post('/account/role/update', para)
}

//新增
export const addUsert = (para) => {
  return instance.post('/account/role/add',  para)
}

//拍卖消息
export const getAuction = (para) => {
  return instance.post('/auction/message/list',  para)
}


//招商消息
export const getCanvass = (para) => {
  return instance.post('/enrolling/message/list',  para)
}
